import React, { Component } from 'react';
import { Dropdown, Button, Modal } from 'semantic-ui-react';
import _ from 'lodash';
import { getAccounts } from '../../services/AccountService';

class UtmAccountsSelectionModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      accountOptions: [],
      selectedAccounts: [],
      selectedAccountOptions: []
    };
  }

  componentDidMount() {
    this.getAdAccounts();
  }
  // to do: populate dropdown with prefill accounts
  getAdAccounts = async () => {
    const { initialUtmAccounts } = this.props;
    let utmAccounts = [];
    let filteredOptions = [];

    try {
      const result = await getAccounts();

      const accountOptions = _.sortBy(
        _.map(result, (op, index) => ({
          key: index,
          value: op.account_id,
          text: op.name
        })),
        'text'
      );

      if (initialUtmAccounts && initialUtmAccounts.length > 0) {
        utmAccounts = initialUtmAccounts;
        filteredOptions = utmAccounts.map((account) => account.accountId);
      }

      this.setState({
        accountOptions,
        selectedAccounts: utmAccounts,
        selectedAccountOptions: filteredOptions
      });
    } catch (error) {
      console.log(error);
    }
  };

  toggleModal = () => {
    const { toggleUtmAccountsModal } = this.props;
    if (toggleUtmAccountsModal) {
      this.setState(
        { selectedAccounts: [], selectedAccountOptions: [] },
        () => {
          toggleUtmAccountsModal();
        }
      );
    }
  };

  onAccountSelect = (event, { value, options }) => {
    const filteredOptions = options.filter((option) =>
      value.includes(option.value)
    );

    const filteredOptionIds = filteredOptions.map((option) => option.value);

    const mappedFilteredOptions = filteredOptions.map((filteredOption) => {
      const { text: accountName, value: accountId } = filteredOption;
      return {
        accountName,
        accountId
      };
    });

    this.setState((prevState) => ({
      ...prevState,
      selectedAccounts: mappedFilteredOptions,
      selectedAccountOptions: filteredOptionIds
    }));
  };

  setUtmAccounts = (utmAccounts) => {
    const { currentUtmIndex, updateUtmsParentState } = this.props;
    if (updateUtmsParentState) {
      this.setState(
        { selectedAccounts: [], selectedAccountOptions: [] },
        () => {
          updateUtmsParentState(currentUtmIndex, utmAccounts);
        }
      );
    }
  };

  render() {
    const { showUtmAccountsModal } = this.props;
    const {
      selectedAccounts,
      accountOptions,
      selectedAccountOptions
    } = this.state;
    return (
      <Modal
        size="mini"
        dimmer="inverted"
        open={showUtmAccountsModal}
        onClose={this.toggleModal}
      >
        <Modal.Header>Select Accounts for UTM Rule</Modal.Header>
        <Modal.Content>
          <Dropdown
            placeholder="Accounts"
            defaultValue={selectedAccountOptions}
            search
            multiple
            selection
            fluid
            options={accountOptions}
            onChange={this.onAccountSelect}
          />
        </Modal.Content>
        <Modal.Actions>
          <Button color="grey" onClick={() => this.toggleModal()}>
            Cancel
          </Button>
          <Button
            color="blue"
            onClick={() => this.setUtmAccounts(selectedAccounts)}
          >
            Save
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

export default UtmAccountsSelectionModal;



// WEBPACK FOOTER //
// ./src/screens/Utm/UtmAccountsSelectionModal.js